import { registerNotificationKind } from '../registry.js';
/**
 * Module 80's notification kinds (spec 80 §4.8, §8; S80-5), sent through
 * module 50's `NotificationsService` via module 80's `NotificationPort`.
 * `data.content_item_id` and `data.content_title` are always present, except
 * for `style_lessons_ready` (S200-5), which carries `ai_run_id` and `property_id`.
 */
export const AI_CHAIN_FAILED = 'ai_chain_failed';
export const AI_REVISION_NOT_APPLIED = 'ai_revision_not_applied';
export const STYLE_LESSONS_READY = 'style_lessons_ready';
registerNotificationKind({
    kind: AI_CHAIN_FAILED,
    i18nKey: 'notifications.kind.ai_chain_failed',
    mailTemplate: 'ai_chain_failed',
    linkTarget: (data) => `/content/${String(data.content_item_id)}`,
});
registerNotificationKind({
    kind: AI_REVISION_NOT_APPLIED,
    i18nKey: 'notifications.kind.ai_revision_not_applied',
    mailTemplate: 'ai_revision_not_applied',
    linkTarget: (data) => `/content/${String(data.content_item_id)}`,
});
/** S200-5 (spec 80 section 4.16): a `style_learner` run proposed at least one lesson; to holders of `knowledge:write`. */
registerNotificationKind({
    kind: STYLE_LESSONS_READY,
    i18nKey: 'notifications.kind.style_lessons_ready',
    mailTemplate: 'style_lessons_ready',
    linkTarget: () => '/knowledge/voice',
});
//# sourceMappingURL=80.js.map